import { Gender } from "../models/Gender";
import { Products } from "../models/Products";
import { ProductType } from "../models/ProductType";
import { ShoesSize } from "../models/ShoesSize";
import { SizeChart } from "../models/SizeChart";

export class MobileFilterRequest {
    public genderObj: Gender;
    public productTypeObj: ProductType;
    public sizeChartList: Array<SizeChart>;
    public shoesSizeList: Array<ShoesSize>;
    public productsList: Array<Products>;
}
